import { NewsPostType, PostType } from 'src/hook/usePosts'
import { HyperlinkCard, LiveCard } from 'src/components'
import { useVideoEmbed } from 'src/hook/useVideoEmbed'
import { AudioPreview } from 'src/pages/CommunityDetails/Posts/components/audioPreview'
import { useDecision } from '@optimizely/react-sdk'
import { FeedCardImage } from '../feedCardImage'
import { FeedCardVideo } from '../feedCardVideo'
import { FeedCardExternalVideo } from '../feedCardExternalVideo'
import { FeedCardMediaProps } from './feedCardMedia.types'

const FeedCardMedia = ({
  post,
  arrivedFrom,
  commentId,
  className,
  audioComponentName
}: FeedCardMediaProps) => {
  const { youTube } = useVideoEmbed()
  const [featureAudioPost] = useDecision('com_eng_web_enable_audio_post')

  const isYouTubeURL = youTube.isValidURL(post?.description)

  switch (post.postType) {
    case PostType.IMAGE:
      return (
        <FeedCardImage
          post={post}
          commentId={commentId}
          arrivedFrom={arrivedFrom}
          className={className}
        />
      )

    case PostType.URL:
      return isYouTubeURL ? (
        <FeedCardExternalVideo post={post} arrivedFrom={arrivedFrom} className={className} />
      ) : (
        <HyperlinkCard post={post} className={className} />
      )

    case PostType.VIDEO:
      return <FeedCardVideo post={post} arrivedFrom={arrivedFrom} className={className} />

    case PostType.AUDIO:
      if (featureAudioPost.enabled) {
        return (
          <AudioPreview
            postId={post.id}
            className={className}
            isPublication
            componentName={audioComponentName}
          />
        )
      } else {
        return <></>
      }

    case NewsPostType.LIVE:
      return <LiveCard post={post} className={className} />

    default:
      return null
  }
}

export default FeedCardMedia
